import Vue from 'vue'
import MadVue from '@madxnl/mad-vue'
import './scss/main.scss'
import App from './App.vue'
import { store } from './store'
import router from './router'

Vue.use(MadVue)

Vue.config.productionTip = false

// TODO: Use for general "Unauthorized" errors
Vue.config.errorHandler = (err, vm, info) => {
  console.log('errorHandler', [err, vm, info])
  alert(err.message)
}

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
